export enum IUsageIntention {
  WORK = 'WORK',
  STUDIES = 'STUDIES',
  LEISURE = 'LEISURE',
  SHOPPING = 'SHOPPING',
  ADMINISTRATIVE_PROCEDURES = 'ADMINISTRATIVE_PROCEDURES',
  MEDICAL_APPOINTMENTS = 'MEDICAL_APPOINTMENTS',
  FAMILY_VISITS = 'FAMILY_VISITS',
  OTHERS = 'OTHERS'
}